module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-stepper', {
    attrs: {
      "value": _vm.activeStepper,
      "vertical": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('img', {
    attrs: {
      "src": "/src/assets/images/icons/heart-red.svg"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "stepper-title title-content --no-border mb-0 mt-2",
    staticStyle: {
      "font-size": "21px",
      "color": "#1d1d1d"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.changeSurveyText ?
    _vm.$t('UPDATE_YOUR_DATA') :
    _vm.$t('THANK_YOU_FOR_REGISTRATION', {
      name: _vm.user.firstName
    })) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "mb-5",
    staticStyle: {
      "font-size": "16px",
      "font-weight": "400",
      "color": "#1d1d1d"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('ANSWER_BELOW_QUESTIONS')) + "\n        ")])]), _vm._v(" "), _c('section', {
    staticClass: "stepper-section"
  }, [_c('language-selection')], 1), _vm._v(" "), _c('section', {
    staticClass: "stepper-section"
  }, [_c('v-stepper-step', {
    attrs: {
      "step": "1",
      "complete": _vm.activeStepper > 1
    }
  }, [_c('img', {
    attrs: {
      "src": "/src/assets/images/icons/ok-gray.svg"
    }
  }), _vm._v("\n            " + _vm._s(_vm.$t('WHERE_DID_YOU_GET_BRASTER_FROM')) + "\n        ")]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "1"
    }
  }, [_c('survey-step1-q1')], 1)], 1), _vm._v(" "), _c('section', {
    staticClass: "stepper-section"
  }, [_c('v-stepper-step', {
    attrs: {
      "step": "2",
      "complete": _vm.activeStepper > 2
    }
  }, [_c('img', {
    attrs: {
      "src": "/src/assets/images/icons/ok-gray.svg"
    }
  }), _vm._v("\n            " + _vm._s(_vm.$t('PERSONAL_DATA')) + "\n        ")]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "2"
    }
  }, [(_vm.survey.section5.active_section === 1) ? _c('survey-step5-q1') : _vm._e(), _vm._v(" "), (_vm.survey.section5.active_section === 2) ? _c('survey-step5-q2') : _vm._e(), _vm._v(" "), (_vm.survey.section5.active_section === 3) ? _c('survey-ireland-agreement') : _vm._e()], 1)], 1), _vm._v(" "), _c('section', {
    staticClass: "stepper-section"
  }, [_c('v-stepper-step', {
    attrs: {
      "step": "3",
      "complete": _vm.activeStepper > 3
    }
  }, [_c('img', {
    attrs: {
      "src": "/src/assets/images/icons/ok-gray.svg"
    }
  }), _vm._v("\n            " + _vm._s(_vm.$t('CAN_I_USE_BRASTER')) + "\n        ")]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "3"
    }
  }, [(_vm.survey.section2.active_section === 1) ? _c('survey-step2-q1') : _vm._e(), _vm._v(" "), (_vm.survey.section2.active_section === 2) ? _c('survey-step2-q2') : _vm._e(), _vm._v(" "), (_vm.survey.section2.active_section === 3) ? _c('survey-step2-q3') : _vm._e(), _vm._v(" "), (_vm.survey.section2.active_section === 4) ? _c('survey-step2-q4') : _vm._e()], 1), _vm._v(" "), (_vm.survey.section2.disallow_by_pregnant) ? _c('survey-disallowed-by-pregnant', {
    on: {
      "close": _vm.closeModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.survey.section2.disallow_by_breast_cancer) ? _c('survey-disallowed-by-breast-cancer', {
    on: {
      "close": _vm.closeModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.survey.section2.disallow_by_breast_surgery) ? _c('survey-disallowed-by-breast-surgery', {
    on: {
      "close": _vm.closeModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.survey.section2.disallow_by_breast_enlargement) ? _c('survey-disallowed-by-breast-enlargament', {
    on: {
      "close": _vm.closeModal
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('section', {
    staticClass: "stepper-section"
  }, [_c('v-stepper-step', {
    attrs: {
      "step": "4",
      "complete": _vm.activeStepper > 4
    }
  }, [_c('img', {
    attrs: {
      "src": "/src/assets/images/icons/ok-gray.svg"
    }
  }), _vm._v("\n            " + _vm._s(_vm.$t('RISK_FACTORS')) + "\n        ")]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "4"
    }
  }, [(_vm.survey.section3.active_section === 1) ? _c('survey-step3-q1') : _vm._e(), _vm._v(" "), (_vm.survey.section3.active_section === 2) ? _c('survey-step3-q2') : _vm._e(), _vm._v(" "), (_vm.survey.section3.active_section === 3) ? _c('survey-step3-q2-observe') : _vm._e(), _vm._v(" "), (_vm.survey.section3.active_section === 4) ? _c('survey-step3-q3') : _vm._e(), _vm._v(" "), (_vm.survey.section3.active_section === 5) ? _c('survey-step3-q4') : _vm._e(), _vm._v(" "), (_vm.survey.section3.active_section === 6) ? _c('survey-step3-q5') : _vm._e(), _vm._v(" "), (_vm.survey.section3.active_section === 7) ? _c('survey-step3-q5-after') : _vm._e(), _vm._v(" "), (_vm.survey.section3.active_section === 8) ? _c('survey-step3-q6') : _vm._e(), _vm._v(" "), (_vm.survey.section3.active_section === 9) ? _c('survey-step3-q7') : _vm._e(), _vm._v(" "), (_vm.survey.section3.active_section === 10) ? _c('survey-step3-q8') : _vm._e()], 1)], 1), _vm._v(" "), _c('section', {
    staticClass: "stepper-section"
  }, [_c('v-stepper-step', {
    attrs: {
      "step": "5",
      "complete": _vm.activeStepper > 5
    }
  }, [_c('img', {
    attrs: {
      "src": "/src/assets/images/icons/ok-gray.svg"
    }
  }), _vm._v("\n            " + _vm._s(_vm.$t('MEDICAL_DATA')) + "\n        ")]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "5"
    }
  }, [(_vm.survey.section4.active_section === 1) ? _c('survey-step4-q1') : _vm._e(), _vm._v(" "), (_vm.survey.section4.active_section === 2) ? _c('survey-step4-q2') : _vm._e(), _vm._v(" "), (_vm.survey.section4.active_section === 3) ? _c('survey-step4-q3') : _vm._e(), _vm._v(" "), (_vm.survey.section4.active_section === 4) ? _c('survey-step4-q4') : _vm._e(), _vm._v(" "), (_vm.survey.section4.active_section === 5) ? _c('survey-step3-q9') : _vm._e()], 1)], 1), _vm._v(" "), _c('section', {
    staticClass: "stepper-section"
  }, [(_vm.survey.stepperComplete) ? _c('div', {
    staticClass: "stepper-completed"
  }, [_c('img', {
    attrs: {
      "src": "/src/assets/images/icons/ico-ok-green.png"
    }
  }), _vm._v(" "), (!_vm.changeSurveyText) ? _c('h3', [_vm._v(_vm._s(_vm.$t('THANK_YOU')))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t(_vm.changeSurveyText ? 'THANK_YOU_FOR_UPDATE' : 'YOU_CAN_START_BRASTER')))]), _vm._v(" "), _c('button', {
    staticClass: "w160 app-btn app-btn-primary",
    on: {
      "click": _vm.finishSurvey
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('CLOSE_WINDOW')) + "\n            ")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a4523098","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/main-survey/survey.vue
// module id = 1231
// module chunks = 0